import PropTypes from "prop-types"
import classnames from "classnames"
import { formatLongDate } from "helpers/formatters/dates"
import ContributorsDetails from "modules/concentration-contributors"
import "./style.scss"

export default function AnalyzeConcentrationDetails({
  selectedDate,
  selectedValue,
  viewType,
  order,
  hide,
  sort,
  openFactorProfile,
  openSecurityProfile,
  contributorsGrouping,
  setContributorsGrouping,
  selectedGroup,
  showGroup,
  hideGroup,
  selectedBasketGroup,
  showBasketGroup,
  hideBasketGroup,
  selectedOption,
  enableBasketDrillDown,
}) {
  return (
    <div className={classnames("modules_analyze-concentration-details")}>
      <h4 className="header"><span>As of {formatLongDate(selectedDate)}</span></h4>
      <ContributorsDetails {...{
        viewType,
        openSecurityProfile,
        openFactorProfile,
        selectedGroup,
        showGroup,
        hideGroup,
        selectedBasketGroup,
        showBasketGroup,
        hideBasketGroup,
        hide,
        sort,
        order,
        selected: { field: "economicExposure" },
        selectedValue,
        selectedDate,
        setContributorsGrouping,
        contributorsGrouping,
        selectedOption,
        enableBasketDrillDown,
      }}
      />
    </div>
  )
}

AnalyzeConcentrationDetails.propTypes = {
  selectedDate: PropTypes.string,
  selected: PropTypes.object,
  selectedValue: PropTypes.number,
  details: PropTypes.array,
  viewType: PropTypes.string,
  displayType: PropTypes.string,
  order: PropTypes.object,
  show: PropTypes.func,
  hide: PropTypes.func,
  sort: PropTypes.func,
  openFactorProfile: PropTypes.func,
  openSecurityProfile: PropTypes.func,
  contributorsGrouping: PropTypes.object,
  setContributorsGrouping: PropTypes.func.isRequired,
  selectedGroup: PropTypes.object,
  showGroup: PropTypes.func.isRequired,
  hideGroup: PropTypes.func.isRequired,
  selectedBasketGroup: PropTypes.object,
  showBasketGroup: PropTypes.func.isRequired,
  hideBasketGroup: PropTypes.func.isRequired,
  selectedOption: PropTypes.object.isRequired,
  displayTypeName: PropTypes.string.isRequired,
  filtersVisible: PropTypes.bool.isRequired,
  groupSort: PropTypes.func.isRequired,
  groupOrder: PropTypes.object.isRequired,
  enableBasketDrillDown: PropTypes.bool,
}
